module.exports = __webpack_public_path__ + "img/BB.97790982.svg";